var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/coffee"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coffee"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.6,
    d: "M17.79 11.2579V12.7879H2V11.2579C2 8.93785 3.89 7.04785 6.21 7.04785H13.58C15.9 7.04785 17.79 8.93785 17.79 11.2579Z",
    fill: "#66D97F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.4,
    d: "M17.79 12.7878V18.5778C17.79 20.8978 15.9 22.7878 13.58 22.7878H6.21C3.89 22.7878 2 20.8978 2 18.5778V12.7878H17.79Z",
    fill: "#66D97F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.5 5.90784C5.09 5.90784 4.75 5.56784 4.75 5.15784V3.40784C4.75 2.99784 5.09 2.65784 5.5 2.65784C5.91 2.65784 6.25 2.99784 6.25 3.40784V5.15784C6.25 5.57784 5.91 5.90784 5.5 5.90784Z",
    fill: "#66D97F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.5 5.90784C9.09 5.90784 8.75 5.56784 8.75 5.15784V3.40784C8.75 2.99784 9.09 2.65784 9.5 2.65784C9.91 2.65784 10.25 2.99784 10.25 3.40784V5.15784C10.25 5.57784 9.91 5.90784 9.5 5.90784Z",
    fill: "#66D97F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.5 5.90784C13.09 5.90784 12.75 5.56784 12.75 5.15784V3.40784C12.75 2.99784 13.09 2.65784 13.5 2.65784C13.91 2.65784 14.25 2.99784 14.25 3.40784V5.15784C14.25 5.57784 13.91 5.90784 13.5 5.90784Z",
    fill: "#66D97F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M21.65 15.1079C21.65 17.2579 19.91 18.9979 17.76 18.9979V11.2079C19.9 11.2079 21.65 12.9579 21.65 15.1079Z",
    fill: "#66D97F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/coffee.93c18c8c5e6533c6eb424e8d43d007bf.svg";
export { ForwardRef as ReactComponent };